 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import { useFragment, usePreloadedQuery} from 'react-relay'



import TaskFooterIntegrateMenuList from '../../../../../components/TaskFooterIntegrateMenuList'
import TaskFooterIntegrateMenuSignup from '../../../../../components/TaskFooterIntegrateMenuSignup'
import {makePlaceholder, useIsIntegrated} from '../../../../../hooks/useIsIntegrated'















const query = graphql`
  query ExportAllTasksMenuQuery($teamId: ID!) {
    viewer {
      id
      viewerTeamMember: teamMember(userId: null, teamId: $teamId) {
        integrations {
          ...useIsIntegrated_integrations
          ...TaskFooterIntegrateMenuSignup_TeamMemberIntegrations
        }
      }
    }
  }
`

graphql`
  fragment ExportAllTasksMenu_meetingTasks on Task {
    id
    integration {
      id
    }
  }
`

const ExportAllTasksMenu = (props) => {
  const {menuProps, mutationProps, meetingRef, queryRef, handlePushToIntegration} = props
  const data = usePreloadedQuery(query, queryRef)
  const {viewer} = data
  const meeting = useFragment(
    graphql`
      fragment ExportAllTasksMenu_meeting on NewMeeting {
        teamId
        ... on RetrospectiveMeeting {
          tasks {
            ...ExportAllTasksMenu_meetingTasks @relay(mask: false)
          }
        }
        ... on ActionMeeting {
          tasks {
            ...ExportAllTasksMenu_meetingTasks @relay(mask: false)
          }
        }
        ... on TeamPromptMeeting {
          tasks {
            ...ExportAllTasksMenu_meetingTasks @relay(mask: false)
          }
        }
      }
    `,
    meetingRef
  )

  const {viewerTeamMember} = viewer
  const {teamId, tasks} = meeting
  const isViewerIntegrated = useIsIntegrated(_optionalChain([viewerTeamMember, 'optionalAccess', _ => _.integrations]))

  if (!viewerTeamMember) return null
  const {integrations: viewerIntegrations} = viewerTeamMember

  const filteredTasks = _optionalChain([tasks, 'optionalAccess', _2 => _2.filter, 'call', _3 => _3((task) => !task.integration)])

  if (!filteredTasks || filteredTasks.length === 0) {
    return null
  }

  if (isViewerIntegrated) {
    const placeholder = makePlaceholder(isViewerIntegrated)
    const label = 'Push with your credentials'
    return (
      React.createElement(TaskFooterIntegrateMenuList, {
        menuProps: menuProps,
        placeholder: placeholder,
        teamId: teamId,
        onPushToIntegration: handlePushToIntegration,
        label: label,}
      )
    )
  }

  const label = "You don't have any integrations for this team yet."

  return (
    React.createElement(TaskFooterIntegrateMenuSignup, {
      menuProps: menuProps,
      mutationProps: mutationProps,
      teamId: teamId,
      label: label,
      integrationsRef: viewerIntegrations,}
    )
  )
}

export default ExportAllTasksMenu
